<template lang="pug">
v-card.sdo-card(outlined)
  v-list-item.mx-n2.mb-4.secondary.px-6
    v-list-item-content
      .text-caption.white--text Расписание
      .text-body-1.white--text.text-capitalize: strong  {{ currentDay | dp('LLLL yyyy') }}

    v-list-item-action.align-self-center
      .d-flex
        v-btn(color="white" icon @click="prev")
          v-icon() mdi-chevron-left
        v-btn(color="white" icon @click="next")
          v-icon() mdi-chevron-right
  .px-3
    v-row.flex-nowrap(no-gutters)
      v-col(
        v-for="(day, idx) in week"
        :key="day.value"
      ).pr-1
        v-card.text-center.mx-auto.py-1(
          :outlined="day.value === today" flat
          :color="currentDay === day.value ? 'primary': ''"
          :class="currentDay === day.value ? 'white--text': ''"
          @click="currentDay = day.value"
        )
          v-badge(color="success" :value="day.haveLessons")
            div {{ day.value | dp('iiiiii') }}
            strong {{ day.value | dp('d') }}

    .d-flex.px-1(
      v-if="isTeacher && !$user.studentMode && !$route.meta.trained"
    )
      v-btn(
        color="primary"
        small text
        :to=`{
          name: 'ConferenceCreate',
          query: {
            date: currentDay,
          }
        }`
      )
        v-icon(left) mdi-plus-circle-outline
        span Добавить видеотрансляцию

    v-list(v-if="lessonsInCurrentDay.length").mt-2
      lessons-calendar-item.pb-3.pr-1(
        v-for="lesson in lessonsInCurrentDay"
        :key="lesson.id"
        :lesson="lesson"
        @open="openDeleteModule"
      )

    div(v-else)
      v-alert(outlined color="info" text).mt-4
        span На
        strong.mx-1 {{ currentDay | dp('d MMMM') }}
        span нет трансляций
  v-btn(block text color="primary" :to="{ name: 'Schedule' }") Все расписание
    v-icon(right) mdi-arrow-right
</template>

<script>
import { mapGetters } from 'vuex';
import {
  add,
  format,
  startOfWeek,
  endOfWeek,
  addDays,
  getWeekOfMonth,
  getMonth,
  getYear,
  isSameDay,
  // isBefore,
  // isAfter,
  // startOfDay,
  // endOfDay,
} from 'date-fns';

import LessonsCalendarItem from './LessonsCalendarItem.vue';

const today = format(new Date(), 'yyyy-MM-dd');

export default {
  name: 'LessonsCalendar',
  components: {
    LessonsCalendarItem,
  },
  props: {
    courseId: { type: Number, default: null },
  },
  data() {
    return {
      currentDay: today,
      today,

      lessons: [],
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      isTeacher: 'auth/isTeacher',
      userData: 'auth/userData',
    }),
    currentWeek() {
      return getWeekOfMonth(new Date(this.currentDay), { weekStartsOn: 1 });
    },

    lessonsInCurrentDay() {
      return this.lessons
        .filter((lesson) => isSameDay(new Date(lesson.date_start), new Date(this.currentDay)));
    },

    currentMonth() {
      return getMonth(new Date(this.currentDay), { weekStartsOn: 1 });
    },
    currentYear() {
      return getYear(new Date(this.currentDay), { weekStartsOn: 1 });
    },

    week() {
      const { currentDay } = this;

      const weekStartDay = startOfWeek(new Date(currentDay), { weekStartsOn: 1 });
      return Array(7).fill().map((_, idx) => {
        const value = format(addDays(weekStartDay, idx), 'yyyy-MM-dd');
        return {
          haveLessons: this.lessons.findIndex(({ date_start: start }) => {
            const isFeature = new Date(start) > new Date();
            return isFeature && start.split(' ')[0] === value;
          }) !== -1,
          value,
        };
      });
    },
  },
  watch: {
    currentWeek() {
      this.getSchedule();
    },
    courseId() {
      this.getSchedule();
    },
  },
  created() {
    this.getSchedule();
  },
  methods: {
    next() {
      this.currentDay = format(
        startOfWeek(
          add(new Date(this.currentDay), { weeks: 1 }),
          { weekStartsOn: 1 },
        ),
        'yyyy-MM-dd',
      );
    },
    prev() {
      this.currentDay = format(
        startOfWeek(
          add(new Date(this.currentDay), { weeks: -1 }),
          { weekStartsOn: 1 },
        ),
        'yyyy-MM-dd',
      );
    },

    openDeleteModule(id) {
      debugger;
      this.$modals.show('confirm-controller', {
        type: 'error',
        title: 'Удаление конференции',
        message: 'Подтвердите удаление конференции',
        method: async () => {
          await this.$api.telegram.conferenceDelete(id);
          const idx = this.lessons.findIndex((i) => i.id === id);
          this.lessons.splice(idx, 1);
          this.$modals.close();
          this.$toasted.success('Конференция успешно удалена');
        },
      });
    },

    async getSchedule() {
      this.loading = true;
      const date = new Date(this.currentDay);
      const startDate = startOfWeek(date);
      const endDate = endOfWeek(date);
      const query = {
        sort: 'date_start',
        'per-page': -1,
        'search[from_date]': startDate,
        'search[to_date]': endDate,
        'search[course_id]': this.courseId,
        ...this.$user.isTeacher ? {
          'search[teacher_id]': this.$user.studentMode ? null : this.$user.data.teacher_id,
          'search[im_learning]': this.$user.studentMode || null,
          'search[me_and_open]': this.$user.studentMode || null,
        } : {
          'search[me_and_open]': true,
        },
        expand: 'users,groups,prior_records,courses',
      };
      const { items } = await this.$api.telegram.conferenceIndex(query);

      this.lessons = items;
      this.loading = false;
    },
  },
};
</script>
